import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSinCanonica } from "@/publico/cabecera";
import { esRutaPublica } from "@/publico/enlaces";

// Página para rutas que no existen (antes salían en blanco).
export default function NoEncontrada() {
  const { pathname } = useLocation();
  useSinCanonica();
  useEffect(() => {
    document.title = "Página no encontrada | NuvliPro";
    // Una página pública que acaba aquí por un fallo (p. ej. la caché de rastreadores renderizando a mitad de un despliegue) no se marca noindex.
    if (esRutaPublica(pathname)) return undefined;
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => m.remove();
  }, [pathname]);
  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-sky-50 to-[#E0F2FE]/40 px-6">
      <div className="max-w-md text-center">
        <p className="text-6xl font-bold text-[#0284C7]">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-slate-900">Página no encontrada</h1>
        <p className="mt-3 text-slate-600">La página que buscas no existe o ha cambiado de dirección.</p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-lg bg-[#0284C7] px-6 py-3 font-medium text-white hover:bg-[#0369A1]"
        >
          Volver a la portada
        </Link>
      </div>
    </main>
  );
}
